import { useCategoryProductController } from "../../controller/components/categoryProduct";
import { SuppliesCategoryProduct } from "../../../../models/suppliesCategoryProduct";
import { SuppliesDivisionModel } from "../../../../models/suppliesDivisionModel";
import { Dialog, Box, Typography, Grid, TextField, Button, useTheme, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { useTranslation } from "react-i18next";

interface Props {
    onOpen: boolean
    onClose: VoidFunction,
    selectedCat: SuppliesCategoryProduct,
    onfetch: VoidFunction,
    selected: Function,
    DivId: SuppliesDivisionModel
}



const FormCategoryProduct = ({ onOpen, onClose, selectedCat, onfetch, selected, DivId }: Props) => {
    const controllers = useCategoryProductController({ selectedCat, DivId , onOpen , onClose ,onfetch , selected});
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation('global');


    return <Dialog
        fullWidth
        maxWidth={'lg'}
        open={true}
        sx={{ display: onOpen ? "block" : "none" }}
    >
        <Box sx={{ p: isSmallScreen ? 2 : 6 }}>
            <form onSubmit={(e) => controllers.handleOpenForm(e)}>
                <Box mb={isSmallScreen ? 1 : 2}>
                    <Typography variant="h4">{selectedCat ? t("masterCategory_page.Update Category Product") : t("masterCategory_page.Create Category Product")}</Typography>
                </Box>
                <Grid container spacing={isSmallScreen ? 1 : 2}>
                    <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
                        <Box sx={{
                            p: isSmallScreen ? 2 : 4, boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        }}>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Category Product Code")}</Typography>
                                    <TextField fullWidth inputRef={controllers.catCode} required size="small" margin="normal" />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Name la")}</Typography>
                                    <TextField fullWidth inputRef={controllers.nameLa} required size="small" margin="normal" />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Name en")}</Typography>
                                    <TextField fullWidth inputRef={controllers.nameEn} required size="small" margin="normal" />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
                        <Box mt={isSmallScreen ? 1 : 2} sx={{
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            width: '100%',
                            height: '80%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#F4F6F8',
                        }}>
                            <Box >
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                    <label htmlFor="image-input-category-product">
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#EBEBEB', width: isSmallScreen ? 100 : 150, height: isSmallScreen ? 100 : 150, borderRadius: "10px", cursor: 'pointer' }}>
                                            {
                                                controllers.imageToShow ? <img src={controllers.imageToShow} style={{ width: isSmallScreen ? 100 : 200 , height:isSmallScreen ? 100 : 200 , borderRadius:'10px'}} alt='' /> :
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <AddIcon />
                                                        <Typography>{t("masterCategory_page.Add Image")}</Typography>
                                                    </Box>
                                            }
                                        </Box>
                                    </label>
                                    <input
                                        type="file"
                                        id="image-input-category-product"
                                        onClick={(e: any) => {
                                            e.target.value = '';
                                        }}
                                        onChange={controllers.handleSelectImage}
                                        style={{ display: 'none' }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={isSmallScreen ? 1 : 2}>
                    {controllers.imageError && <Typography mt={1} color='error'>{controllers.imageError}</Typography>}
                    {controllers.errorMessage && <Typography mt={1} color='error'>{controllers.errorMessage}</Typography>}
                </Box>
                <Box mt={isSmallScreen ? 4 : 2} sx={{ display: 'flex', justifyContent:isSmallScreen ? 'center' : 'end' }}>
                    <Button onClick={() => { onClose(); controllers.handleReset() }} variant="outlined" color='error' sx={{ textTransform: 'none', width: 100 }}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained" color="secondary" sx={{ textTransform: 'none', color: '#fff', ml: 2, width: 180 }}>
                        {selectedCat ? t("masterCategory_page.Update Category Product") : t("masterCategory_page.Create Category Product")}
                    </Button>
                </Box>
                <ConfirmDialog
                    open={controllers.openConfirmForm}
                    title={`${selectedCat ? t("masterCategory_page.Do yo want to update this Category Product ?") : t("Do you want to Create this Category Product ?")} `}
                    loading={controllers.loadingConfirmButton}
                    onCancel={controllers.handleCloseConfirmForm}
                    onConfirm={() => controllers.handleSubmit()}
                />
            </form>
        </Box>
    </Dialog>
}
export default FormCategoryProduct;